export default "__VITE_ASSET__ClslvMkl__"